import { Grid } from '@mantine/core';
import { PodcastGridProps } from './types';
import { FC } from 'react';
import { PodcastCard } from '@molecules/frontoffice/PodcastCard';
import { InView } from 'react-intersection-observer';

export const PodcastGrid: FC<PodcastGridProps> = ({
  podcasts,
  hasNextPage,
  fetchNextPage,
}) => {
  return (
    <Grid columns={4} gutterLg={44}>
      {podcasts?.map((podcast, index) => (
        <Grid.Col span={4} md={2} lg={1} key={podcast.id}>
          {podcasts.length - 1 === index ? (
            <InView
              as="div"
              style={{ padding: 0, margin: 0 }}
              onChange={(inView) => {
                if (hasNextPage && inView && podcasts.length - 1 === index) {
                  fetchNextPage();
                }
              }}
              key={index}
              threshold={0.8}
            >
              <PodcastCard podcast={podcast} />
            </InView>
          ) : (
            <PodcastCard podcast={podcast} />
          )}
        </Grid.Col>
      ))}
    </Grid>
  );
};
